export default function bindEvents(element, events) {
    for (var eventName in events) {
        var eventNames = eventName.trim().split(" ");
        for (var idx = 0; idx < eventNames.length; idx++) {
            element.addEventListener(eventNames[idx], events[eventName], false);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/util/bind-events.js